import * as React from "react";
import { useTranslation } from "react-i18next";

import { AuthCard, ResetPasswordForm } from "@/components/auth";

export function ResetPasswordPage() {
  const { t } = useTranslation("auth");

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <AuthCard title={t("resetPassword.title")} description={t("resetPassword.subtitle")}>
        <ResetPasswordForm />
      </AuthCard>
    </div>
  );
}

export default ResetPasswordPage;
